import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import classes from './style.module.scss';
import { Carousel } from 'react-responsive-carousel';
import { ClubImages } from '../../ExportClubImages/ExportClubImages';

const Hall = () => {
    return (
        <div className={classes.container}>
            <div>
                <h2 className={classes.hallTitle}>Наш зал</h2>
                <Carousel
                    className={classes.slider}
                    infiniteLoop={true}
                    showStatus={false}
                    emulateTouch={true}
                    showArrows={true}
                >
                    {ClubImages.map((item, index) => (
                        <div key={index}>
                            <img
                                className={classes.hallPicture}
                                src={item}
                                alt="Зал"
                            />
                        </div>
                    ))}
                </Carousel>
            </div>
        </div>
    );
};

export default Hall;
